import React, { ComponentType, ErrorInfo } from 'react';
import ErrorBoundary from './ErrorBoundary';

export interface ErrorHOCOptions {
  isAuthorMode?: boolean;
  onError?: (error: Error, errorInfo: ErrorInfo, componentName: string) => void;
}

export const ErrorHOC = <T extends object>(
  Component: ComponentType<T>,
  componentName: string,
  options: ErrorHOCOptions = {}
) => {
  const WrappedComponent = (props: T & { isAuthorMode?: boolean }) => {
    const { isAuthorMode, onError } = options;
    const resolvedIsAuthorMode = isAuthorMode ?? props.isAuthorMode;

    return (
      <ErrorBoundary componentName={componentName} isAuthorMode={resolvedIsAuthorMode} onError={onError}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };

  WrappedComponent.displayName = `ErrorHOC(${componentName})`;
  return WrappedComponent;
};

export const withErrorBoundary = <T extends object>(
  Component: ComponentType<T>,
  componentName: string,
  options: ErrorHOCOptions = {}
) => ErrorHOC(Component, componentName, options);

export { default as ErrorBoundary } from './ErrorBoundary';
